/*!
 * MYZOO 新春ガラポン  <myzoo-garapon>  v1.0.0
 * Self-contained Web Component (Shadow DOM). No dependencies.
 *
 * The component only handles the look and the "turn the handle" interaction.
 * The prize itself MUST be decided by your server: set `element.drawHandler`
 * to an async function that calls your backend and returns { rank, code? }.
 * See README.md for the full API.
 */
(function () {
  "use strict";
  if (!window.customElements || customElements.get("myzoo-garapon")) return;

  var SVGNS = "http://www.w3.org/2000/svg";
  var CX = 195, CY = 170;

  var DEFAULT_PRIZES = {
    1: { label: "1等", name: "Loop Tower（ホワイト）", color: "#a2443c", type: "goods" },
    2: { label: "2等", name: "Chillax", color: "#8f6b37", type: "goods" },
    3: { label: "3等", name: "Locus", color: "#5b7182", type: "goods" },
    4: { label: "4等", name: "Cylinder", color: "#5f7464", type: "goods" },
    5: { label: "5等", name: "猫用トイレ", color: "#756379", type: "goods" },
    6: { label: "6等", name: "1,000円クーポン", color: "#7c5d4c", type: "coupon" }
  };

  var DEFAULT_TEXTS = {
    turnsLeft: "あと{n}周",
    almost: "もう少し！",
    hintStart: "ハンドルの赤い持ち手を押さえて回してください",
    hintGoing: "その調子です。手を止めずに回しましょう",
    drawing: "玉が出ます",
    drawingSub: "そのままお待ちください",
    doneTitle: "抽選済みです",
    doneSub: "ガラポンはお一人さま1回までです。",
    showResult: "抽選結果を見る",
    errorTitle: "うまく抽選できませんでした",
    errorSub: "通信状況をご確認のうえ、もう一度ハンドルを回してください",
    congrats: "おめでとうございます",
    goodsText: "当選結果は記録されました。MYZOOの担当者から後日メールでご連絡いたします。",
    goodsNote: "",
    couponLabel: "あなた専用のクーポンコード",
    couponText: "お買い物の際、決済画面でこのコードを入力してください。お一人さま1回限り使えます。",
    couponNote: "",
    copy: "コードをコピー",
    copied: "コピーしました",
    copySelected: "選択しました。長押しでコピーできます",
    close: "閉じる",
    soundOn: "音あり",
    soundOff: "音なし",
    lockedDefault: "会員ログインすると、ハンドルを回せるようになります。",
    handleLabel: "ガラポンのハンドル。矢印キーでも回せます",
    words: ["ガラ", "ガラ", "カラン"]
  };

  /* ------------------------------------------------------------------ */
  /* styles                                                              */
  /* ------------------------------------------------------------------ */
  var CSS = [
    ":host{display:block;max-width:560px;margin-inline:auto;",
    "--_felt:var(--gp-felt,#a5272b);--_felt-2:var(--gp-felt-dark,#8c1f23);",
    "--_accent:var(--gp-accent,#b5302a);--_accent-2:var(--gp-accent-dark,#8e221d);",
    "--_gold:var(--gp-gold,#a9843a);--_gold-2:var(--gp-gold-light,#d9bf80);",
    "--_ink:var(--gp-ink,#2a211c);--_ink-2:var(--gp-ink-soft,#5e5048);",
    "--_paper:var(--gp-paper,#fffaf0);--_line:var(--gp-line,#dccbaa);",
    "--_fd:var(--gp-font-display,\"Shippori Mincho B1\",\"Hiragino Mincho ProN\",\"Yu Mincho\",\"Noto Serif JP\",serif);",
    "--_fb:var(--gp-font-body,\"Zen Kaku Gothic New\",\"Hiragino Sans\",\"Yu Gothic\",\"Noto Sans JP\",sans-serif);",
    "font-family:var(--_fb);color:var(--_ink);line-height:1.7}",
    ":host([hidden]){display:none}",
    "*{box-sizing:border-box}[hidden]{display:none!important}p,h3{margin:0}",
    ".stage{position:relative}",
    ".machine-wrap{position:relative}",
    "svg.machine{display:block;width:100%;height:auto;overflow:visible;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}",
    ".stage.is-locked svg.machine{filter:saturate(.75);opacity:.6}",
    ".sound{position:absolute;right:0;top:0;z-index:2;display:inline-flex;gap:6px;align-items:center;font:500 12px var(--_fb);color:var(--_ink-2);background:var(--_paper);border:1px solid var(--_line);border-radius:999px;padding:5px 11px;cursor:pointer}",
    ".sound svg{width:15px;height:15px}",
    ".sound:focus-visible,.btn:focus-visible{outline:3px solid var(--_gold);outline-offset:3px}",
    ".grain{fill:none;stroke:#94622f;stroke-width:1.1;opacity:.35;stroke-linecap:round}",
    ".seam{stroke:#94622f;stroke-width:1;opacity:.45}",
    ".knob-hit{fill:transparent;cursor:grab;touch-action:none}",
    ".arm-hit{fill:none;stroke:transparent;stroke-width:36;stroke-linecap:round;cursor:grab;touch-action:none;pointer-events:stroke}",
    ".dragging .knob-hit,.dragging .arm-hit{cursor:grabbing}",
    ".handle{outline:none}",
    ".handle:focus-visible .knob-ring{stroke:var(--_gold);stroke-width:3}",
    ".stage.is-locked .handle,.stage.is-done .handle{pointer-events:none}",
    ".pulse{fill:none;stroke:var(--_gold);stroke-width:2.5;transform-box:fill-box;transform-origin:center;animation:gp-pulse 1.6s ease-out infinite}",
    "@keyframes gp-pulse{0%{transform:scale(.85);opacity:.9}100%{transform:scale(1.6);opacity:0}}",
    ".stage:not(.is-ready) .pulse{display:none}",
    ".hint{fill:none;stroke:var(--_gold);stroke-width:2;stroke-dasharray:5 6}",
    ".hint-head{fill:var(--_gold)}",
    ".hint-g{transition:opacity .4s}",
    ".stage:not(.is-ready) .hint-g{opacity:0}",
    ".word{font-family:var(--_fd);font-weight:800;font-size:20px;fill:var(--_accent);transform-box:fill-box;transform-origin:center;animation:gp-word .9s ease-out forwards}",
    "@keyframes gp-word{0%{opacity:0;transform:translateY(6px) scale(.8)}20%{opacity:1}100%{opacity:0;transform:translateY(-26px) scale(1.05)}}",
    ".lock{position:absolute;inset:14% 4% auto;z-index:3;background:rgba(255,250,240,.95);border:1px solid var(--_line);border-radius:14px;box-shadow:0 18px 40px rgba(42,33,28,.16);padding:22px 20px;text-align:center;font-size:14px;color:var(--_ink-2)}",
    ".panel{background-color:var(--_felt);color:#f8eddb;padding:13px 16px 26px;text-align:center;border-radius:0 0 18px 18px;box-shadow:inset 0 -6px 0 var(--_felt-2)}",
    ".turns{display:flex;justify-content:center;gap:12px}",
    ".slot{--p:0;width:22px;height:22px;border-radius:50%;background:conic-gradient(var(--_gold-2) calc(var(--p) * 1turn),rgba(255,240,220,.16) 0);box-shadow:inset 0 0 0 2px rgba(255,240,220,.45)}",
    ".p-title{margin-top:8px;font-family:var(--_fd);font-weight:800;font-size:20px;letter-spacing:.1em;font-variant-numeric:tabular-nums}",
    ".p-sub{font-size:12.5px;opacity:.85;margin-top:2px}",
    ".p-done{display:flex;flex-direction:column;gap:10px;align-items:center;padding-top:4px}",
    ".btn{display:inline-flex;align-items:center;justify-content:center;gap:10px;font:700 15px var(--_fb);letter-spacing:.08em;border-radius:999px;padding:12px 24px;cursor:pointer;border:0;transition:transform .15s ease,background-color .15s}",
    ".btn-primary{background:var(--_accent);color:var(--_paper);box-shadow:0 3px 0 var(--_accent-2)}",
    ".btn-primary:active{transform:translateY(2px);box-shadow:0 1px 0 var(--_accent-2)}",
    ".btn-light{background:var(--_paper);color:var(--_accent);box-shadow:0 3px 0 rgba(0,0,0,.18)}",
    ".modal{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:max(20px,env(safe-area-inset-top,0px)) max(16px,env(safe-area-inset-right,0px)) max(20px,env(safe-area-inset-bottom,0px)) max(16px,env(safe-area-inset-left,0px))}",
    ".modal-bg{position:absolute;inset:0;background:rgba(42,33,28,.55);animation:gp-fade .25s ease}",
    ".sheet{position:relative;width:100%;max-width:380px;max-height:100%;overflow:auto;background:var(--_paper);border-radius:18px;box-shadow:0 24px 60px rgba(0,0,0,.3);animation:gp-rise .45s cubic-bezier(.2,.9,.25,1.15)}",
    "@keyframes gp-fade{from{opacity:0}}",
    "@keyframes gp-rise{from{transform:translateY(24px) scale(.94);opacity:0}}",
    ".sheet-band{height:30px;border-bottom:1px solid var(--_line);background-color:#f3e9d3}",
    ".sheet-body{padding:6px 24px 26px;text-align:center;display:flex;flex-direction:column;align-items:center;gap:6px}",
    ".burst{position:relative;width:150px;height:150px;display:grid;place-items:center;margin-top:4px}",
    ".rays{position:absolute;inset:0;width:100%;height:100%;animation:gp-spin 18s linear infinite}",
    ".ray{fill:var(--_gold-2);opacity:.55}",
    "@keyframes gp-spin{to{transform:rotate(360deg)}}",
    ".big-ball{--ball:#fff;width:84px;height:84px;border-radius:50%;position:relative;animation:gp-pop .6s cubic-bezier(.2,1.4,.4,1) both;",
    "background:radial-gradient(circle at 34% 30%,rgba(255,255,255,.8) 0 9%,rgba(255,255,255,0) 30%),radial-gradient(circle at 62% 72%,rgba(0,0,0,.2),rgba(0,0,0,0) 62%),var(--ball);box-shadow:inset 0 0 0 1px rgba(42,33,28,.18)}",
    "@keyframes gp-pop{from{transform:scale(.2)}}",
    ".prize-photo{position:relative;z-index:2;width:132px;height:132px;object-fit:contain;filter:drop-shadow(0 6px 10px rgba(42,33,28,.14))}",
    ".prize-photo[hidden]{display:none!important}",
    ".m-eye{font-family:var(--_fd);font-weight:600;letter-spacing:.18em;color:var(--_gold);font-size:14px}",
    ".m-rank{font-family:var(--_fd);font-weight:800;font-size:40px;color:var(--_accent);letter-spacing:.06em;line-height:1.2}",
    ".m-prize{font-family:var(--_fd);font-weight:800;font-size:21px;letter-spacing:.04em}",
    ".m-text{font-size:13.5px;color:var(--_ink-2);margin-top:6px;text-align:left}",
    ".m-small{font-size:12px;color:var(--_ink-2);opacity:.85;text-align:left}",
    ".coupon{margin-top:8px;width:100%;border:1.5px dashed var(--_accent);border-radius:12px;padding:12px;background:#fff6ec}",
    ".coupon .lab{font-size:12px;color:var(--_ink-2);letter-spacing:.1em}",
    ".coupon .code{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:21px;font-weight:700;letter-spacing:.08em;color:var(--_ink);user-select:all;-webkit-user-select:all;margin:2px 0 8px;word-break:break-all}",
    ".coupon .btn{padding:8px 18px;font-size:13.5px}",
    ".close{margin-top:14px;width:100%}",
    "canvas.confetti{position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483001}",
    "@media (prefers-reduced-motion:reduce){.pulse,.rays,.big-ball,.sheet,.modal-bg{animation:none}}"
  ].join("\n");

  /* ------------------------------------------------------------------ */
  /* helpers                                                             */
  /* ------------------------------------------------------------------ */
  function el(tag, attrs, parent) {
    var n = document.createElementNS(SVGNS, tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function plumFlower(parent, cx, cy, size, color) {
    var g = el("g", { transform: "translate(" + cx + " " + cy + ") scale(" + (size / 24) + ")" }, parent);
    for (var i = 0; i < 5; i++) {
      var a = (-90 + i * 72) * Math.PI / 180;
      el("circle", { cx: (Math.cos(a) * 6.2).toFixed(2), cy: (Math.sin(a) * 6.2).toFixed(2), r: 5.3, fill: color }, g);
    }
    el("circle", { r: 2.6, fill: "#f3d48c" }, g);
    el("path", { d: "M0 0 L0 -4.2M0 0 L4 -1.3M0 0 L2.5 3.4M0 0 L-2.5 3.4M0 0 L-4 -1.3", stroke: "#f3d48c", "stroke-width": ".9", "stroke-linecap": "round" }, g);
    return g;
  }
  // half-height of the inner drum face (regular octagon) at horizontal offset dx from centre
  function faceHalf(x) {
    var dx = Math.abs(x - CX);
    return dx <= 38.27 ? 92.39 : Math.max(0, 92.39 - (dx - 38.27));
  }
  function seigaiha(r, stroke, fill) {
    var dpr = 2, w = 2 * r, h = r, c = document.createElement("canvas");
    c.width = w * dpr; c.height = h * dpr;
    var x = c.getContext("2d"); x.scale(dpr, dpr); x.lineWidth = 1.1; x.strokeStyle = stroke;
    for (var j = -4; j <= 8; j++) {
      var y = j * r / 2, off = (((j % 2) + 2) % 2) ? r : 0;
      for (var i = -2; i <= 2; i++) {
        var cx = i * 2 * r + off;
        x.beginPath(); x.arc(cx, y, r - .6, 0, Math.PI * 2); x.fillStyle = fill; x.fill(); x.stroke();
        [.78, .56, .34, .13].forEach(function (f) { x.beginPath(); x.arc(cx, y, r * f, 0, Math.PI * 2); x.stroke(); });
      }
    }
    return { url: c.toDataURL(), size: w + "px " + h + "px" };
  }
  var reduceMotion = function () { return !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches); };

  /* ------------------------------------------------------------------ */
  /* sound (Web Audio, no files)                                         */
  /* ------------------------------------------------------------------ */
  function Sound() { this.on = true; this.ac = null; this.noise = null; }
  Sound.prototype.ctx = function () {
    if (!this.on) return null;
    try {
      if (!this.ac) this.ac = new (window.AudioContext || window.webkitAudioContext)();
      if (this.ac.state === "suspended") this.ac.resume();
      if (!this.noise) {
        this.noise = this.ac.createBuffer(1, this.ac.sampleRate * 0.2, this.ac.sampleRate);
        var d = this.noise.getChannelData(0);
        for (var i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
      }
      return this.ac;
    } catch (e) { return null; }
  };
  Sound.prototype.clack = function () {
    var a = this.ctx(); if (!a) return; var self = this;
    [0, .028].forEach(function (off, i) {
      var t = a.currentTime + off + Math.random() * .01;
      var s = a.createBufferSource(); s.buffer = self.noise;
      var f = a.createBiquadFilter(); f.type = "bandpass"; f.frequency.value = 1500 + Math.random() * 1800; f.Q.value = 7;
      var g = a.createGain(); g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(i ? .18 : .32, t + .004); g.gain.exponentialRampToValueAtTime(.0001, t + .07);
      s.connect(f); f.connect(g); g.connect(a.destination); s.start(t); s.stop(t + .09);
    });
  };
  Sound.prototype.koron = function (v) {
    var a = this.ctx(); if (!a) return; var t = a.currentTime;
    [[1320, 1], [2640, .35]].forEach(function (h) {
      var o = a.createOscillator(), g = a.createGain(); o.type = "sine"; o.frequency.value = h[0];
      g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(Math.max(.0002, .22 * v * h[1]), t + .005); g.gain.exponentialRampToValueAtTime(.0001, t + .28);
      o.connect(g); g.connect(a.destination); o.start(t); o.stop(t + .3);
    });
  };
  Sound.prototype.chime = function (big) {
    var a = this.ctx(); if (!a) return;
    (big ? [784, 988, 1175, 1568, 1976] : [880, 1175, 1568]).forEach(function (fq, i) {
      var t = a.currentTime + i * .11, o = a.createOscillator(), g = a.createGain();
      o.type = "triangle"; o.frequency.value = fq;
      g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(.16, t + .01); g.gain.exponentialRampToValueAtTime(.0001, t + 1.1);
      o.connect(g); g.connect(a.destination); o.start(t); o.stop(t + 1.2);
    });
  };

  /* ------------------------------------------------------------------ */
  /* component                                                           */
  /* ------------------------------------------------------------------ */
  class MyzooGarapon extends HTMLElement {
    static get observedAttributes() { return ["state", "turns"]; }

    constructor() {
      super();
      this._prizes = JSON.parse(JSON.stringify(DEFAULT_PRIZES));
      this._texts = Object.assign({}, DEFAULT_TEXTS);
      this.drawHandler = null;
      this._phase = "ready";
      this._theta = 0; this._total = 0; this._vel = 0; this._dir = 1;
      this._dragging = false; this._lastAng = 0; this._lastT = 0; this._raf = 0;
      this._result = null; this._wordIdx = 0; this._built = false;
      this._sound = new Sound();
      this._uid = "gp" + Math.random().toString(36).slice(2, 8);
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onKeyEsc = this._onKeyEsc.bind(this);
    }

    /* ---------- public properties ---------- */
    get prizes() { return JSON.parse(JSON.stringify(this._prizes)); }
    set prizes(v) {
      if (!v || typeof v !== "object") return;
      for (var k in v) this._prizes[k] = Object.assign({}, this._prizes[k] || {}, v[k]);
    }
    get texts() { return Object.assign({}, this._texts); }
    set texts(v) {
      if (!v || typeof v !== "object") return;
      Object.assign(this._texts, v);
      if (this._built) this._applyTexts();
    }
    get phase() { return this._phase; }
    get result() { return this._result ? Object.assign({}, this._result) : null; }
    get sound() { return this._sound.on; }
    set sound(on) { this._sound.on = !!on; if (this._built) this._applySoundBtn(); }

    /* ---------- lifecycle ---------- */
    connectedCallback() {
      if (!this._built) { this._build(); this._built = true; }
      document.addEventListener("touchmove", this._onTouchMove, { passive: false });
      document.addEventListener("keydown", this._onKeyEsc);
      if (this._phase !== "done") this._resetMachine();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._raf);
      document.removeEventListener("touchmove", this._onTouchMove);
      document.removeEventListener("keydown", this._onKeyEsc);
    }
    attributeChangedCallback(name) {
      if (!this._built) return;
      if (name === "turns") { this._buildSlots(); this._updateProgress(); }
      if (name === "state" && this._phase !== "done" && this._phase !== "finishing") this._resetMachine();
    }

    /* ---------- public methods ---------- */
    /** Show a result the member already drew earlier (e.g. after reload). */
    showDrawn(result) {
      if (!this._validResult(result)) { console.warn("[myzoo-garapon] showDrawn: invalid result", result); return; }
      this._closeModal();
      cancelAnimationFrame(this._raf);
      this._theta = 0; this._total = 0; this._render();
      this._result = { rank: Number(result.rank), code: result.code || "" };
      this._phase = "done";
      this._setBall(this._result.rank, 201, 307, 1);
      this._syncStage();
    }
    /** Open the result popup again (only when a result exists). */
    openResult() { if (this._result) this._showModal(false); }
    /** Back to the initial state. */
    reset() { this._result = null; this._closeModal(); this._resetMachine(); }

    /* ---------- build ---------- */
    _build() {
      var root = this.attachShadow({ mode: "open" });
      root.innerHTML =
        "<style>" + CSS + "</style>" +
        "<div class='stage' part='stage'>" +
        "  <div class='machine-wrap'>" +
        "    <button type='button' class='sound' aria-pressed='true'><svg viewBox='0 0 24 24' aria-hidden='true'><path d='M4 9h4l5-4v14l-5-4H4z' fill='currentColor'/><path class='sw' d='M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round'/></svg><span class='sound-txt'></span></button>" +
        "    <div class='lock' part='lock' hidden><slot name='locked'><p class='lock-default'></p></slot></div>" +
        "  </div>" +
        "  <div class='panel' part='panel'>" +
        "    <div class='p-progress'><div class='turns' aria-hidden='true'></div><p class='p-title' aria-live='polite'></p><p class='p-sub'></p></div>" +
        "    <div class='p-done' hidden><p class='p-title t-done'></p><p class='p-sub t-done-sub'></p><button type='button' class='btn btn-light again'></button></div>" +
        "  </div>" +
        "</div>" +
        "<div class='modal' part='modal' hidden>" +
        "  <div class='modal-bg'></div>" +
        "  <div class='sheet' role='dialog' aria-modal='true' aria-labelledby='" + this._uid + "-rank'>" +
        "    <div class='sheet-band' aria-hidden='true'></div>" +
        "    <div class='sheet-body'>" +
        "      <div class='burst'><svg class='rays' viewBox='-100 -100 200 200' aria-hidden='true'></svg><div class='big-ball'></div><img class='prize-photo' alt='' loading='eager' hidden></div>" +
        "      <p class='m-eye'></p><h3 class='m-rank' id='" + this._uid + "-rank'></h3><p class='m-prize'></p>" +
        "      <div class='m-goods'><p class='m-text t-goods'></p><p class='m-small t-goods-note'></p></div>" +
        "      <div class='m-coupon' hidden><div class='coupon'><p class='lab'></p><p class='code'></p><button type='button' class='btn btn-primary copy'></button></div><p class='m-text t-coupon'></p><p class='m-small t-coupon-note'></p></div>" +
        "      <button type='button' class='btn btn-primary close'></button>" +
        "    </div>" +
        "  </div>" +
        "</div>" +
        "<canvas class='confetti' aria-hidden='true'></canvas>";

      var $ = function (s) { return root.querySelector(s); };
      this.$stage = $(".stage"); this.$lock = $(".lock"); this.$sound = $(".sound");
      this.$progress = $(".p-progress"); this.$done = $(".p-done");
      this.$slotsBox = $(".turns"); this.$title = $(".p-progress .p-title"); this.$sub = $(".p-progress .p-sub");
      this.$modal = $(".modal"); this.$confetti = $(".confetti");

      this._buildMachine($(".machine-wrap"));
      this._buildSlots();

      // rays + seigaiha band in the popup
      var rays = $(".rays");
      for (var k = 0; k < 16; k++) {
        var a1 = (k / 16) * Math.PI * 2, a2 = a1 + Math.PI / 34;
        el("path", { "class": "ray", d: "M0 0 L" + (Math.cos(a1) * 100).toFixed(1) + " " + (Math.sin(a1) * 100).toFixed(1) + " L" + (Math.cos(a2) * 100).toFixed(1) + " " + (Math.sin(a2) * 100).toFixed(1) + " Z" }, rays);
      }
      try {
        var sg = seigaiha(22, "rgba(169,132,58,.55)", "#f3e9d3"), band = $(".sheet-band");
        band.style.backgroundImage = "url(" + sg.url + ")"; band.style.backgroundSize = sg.size;
      } catch (e) {}

      // events
      var self = this;
      this.$sound.addEventListener("click", function () { self._sound.on = !self._sound.on; self._applySoundBtn(); });
      $(".again").addEventListener("click", function () { self.openResult(); });
      $(".close").addEventListener("click", function () { self._closeModal(); });
      $(".modal-bg").addEventListener("click", function () { self._closeModal(); });
      $(".copy").addEventListener("click", function () { self._copy(this); });
      this.$svg.addEventListener("pointerdown", function (e) {
        if (self._phase === "locked") self._emit("garapon:locked", {});
      });
      this.$lock.addEventListener("click", function (e) {
        if (e.target === self.$lock) self._emit("garapon:locked", {});
      });

      this._applyTexts();
      this._applySoundBtn();
    }

    _buildMachine(wrap) {
      var svg = el("svg", { "class": "machine", viewBox: "15 0 360 380", role: "img", "aria-label": "八角形の木製ガラポン抽選機" });
      wrap.insertBefore(svg, this.$lock);
      this.$svg = svg;
      var defs = el("defs", null, svg);
      var grad = el("radialGradient", { id: this._uid + "-shade", cx: "36%", cy: "30%", r: "78%" }, defs);
      [["0", "#fff", ".75"], [".22", "#fff", "0"], [".7", "#000", "0"], ["1", "#000", ".3"]].forEach(function (s) {
        el("stop", { offset: s[0], "stop-color": s[1], "stop-opacity": s[2] }, grad);
      });

      // felt table
      el("rect", { x: 15, y: 344, width: 360, height: 40, fill: "var(--_felt)" }, svg);
      el("rect", { x: 15, y: 344, width: 360, height: 3, fill: "var(--_felt-2)", opacity: .7 }, svg);
      el("ellipse", { cx: 195, cy: 347, rx: 150, ry: 5, fill: "#2a211c", opacity: .22 }, svg);

      // stand
      el("path", { d: "M189 170 L201 170 L141 334 L121 334 Z", fill: "#3b404d" }, svg);
      el("path", { d: "M189 170 L201 170 L270 334 L250 334 Z", fill: "#3b404d" }, svg);
      el("rect", { x: 140, y: 290, width: 110, height: 7, rx: 2, fill: "#3b404d" }, svg);
      el("rect", { x: 72, y: 328, width: 246, height: 12, rx: 2, fill: "#dcae72" }, svg);
      el("rect", { x: 72, y: 337, width: 246, height: 7, rx: 2, fill: "#94622f" }, svg);

      var OUTER = "M298.47 212.86 L237.86 273.47 L152.14 273.47 L91.53 212.86 L91.53 127.14 L152.14 66.53 L237.86 66.53 L298.47 127.14 Z";
      var INNER = "M287.39 208.27 L233.27 262.39 L156.73 262.39 L102.61 208.27 L102.61 131.73 L156.73 77.61 L233.27 77.61 L287.39 131.73 Z";
      this._spins = [];

      // drum thickness
      var thick = el("g", { transform: "translate(9 7)" }, svg);
      this._spins.push(el("g", null, thick));
      el("path", { d: OUTER, fill: "#6f4622" }, this._spins[0]);

      // drum face
      var drum = el("g", null, svg); this._spins.push(drum);
      el("path", { d: OUTER, fill: "#94622f" }, drum);
      var tones = ["#dcae72", "#e9c690", "#cf9c5f", "#e9c690", "#dcae72", "#cf9c5f", "#e9c690", "#dcae72"];
      var L = 102.61, R = 287.39;
      for (var p = 0; p < 8; p++) {
        var x0 = Math.max(L, 100 + p * 24), x1 = Math.min(R, 124 + p * 24);
        var xs = [x0]; [156.73, 233.27].forEach(function (v) { if (v > x0 && v < x1) xs.push(v); }); xs.push(x1);
        var pts = xs.map(function (x) { return x.toFixed(2) + "," + (CY - faceHalf(x)).toFixed(2); })
          .concat(xs.slice().reverse().map(function (x) { return x.toFixed(2) + "," + (CY + faceHalf(x)).toFixed(2); }));
        el("polygon", { points: pts.join(" "), fill: tones[p] }, drum);
        if (p > 0) el("line", { "class": "seam", x1: x0, x2: x0, y1: (CY - faceHalf(x0)).toFixed(2), y2: (CY + faceHalf(x0)).toFixed(2) }, drum);
        for (var gI = 0; gI < 2; gI++) {
          var gx = 100 + p * 24 + 7 + gI * 9 + Math.random() * 2;
          if (gx < L + 2 || gx > R - 2) continue;
          var h = faceHalf(gx) - 3, y = CY - h, d = "M" + gx.toFixed(1) + " " + y.toFixed(1), seg = (2 * h) / 5;
          for (var s = 1; s <= 5; s++) {
            var ny = CY - h + seg * s;
            d += " Q" + (gx + (Math.random() * 6 - 3)).toFixed(1) + " " + (ny - seg / 2).toFixed(1) + " " + (gx + (Math.random() * 3 - 1.5)).toFixed(1) + " " + ny.toFixed(1);
          }
          el("path", { "class": "grain", d: d }, drum);
        }
      }
      el("path", { d: INNER, fill: "none", stroke: "#6f4622", "stroke-width": 2, opacity: .5 }, drum);
      [[195, 73], [195, 267], [97, 170], [293, 170]].forEach(function (c) { el("circle", { cx: c[0], cy: c[1], r: 2.2, fill: "#f3dcb0", opacity: .55 }, drum); });
      plumFlower(drum, 195, 115, 38, "#b5302a");
      el("circle", { cx: 195, cy: 246, r: 13, fill: "#6f4622" }, drum);
      el("circle", { cx: 195, cy: 246, r: 9, fill: "#24170f" }, drum);
      el("path", { d: "M187.5 243 a8.5 8.5 0 0 1 15 0", fill: "none", stroke: "#f3dcb0", "stroke-width": 1.4, opacity: .4 }, drum);
      el("circle", { cx: 195, cy: 170, r: 18, fill: "#3b404d" }, drum);
      el("circle", { cx: 195, cy: 170, r: 10, fill: "#6c7282" }, drum);

      // tray back
      el("path", { d: "M142 296 L248 296 L243 316 L147 316 Z", fill: "#6f4622" }, svg);
      el("path", { d: "M146 306 L244 306 L242 316 L148 316 Z", fill: "#cf9c5f", opacity: .6 }, svg);

      // ball
      this.$ball = el("g", { visibility: "hidden" }, svg);
      this.$ballFill = el("circle", { r: 10, fill: "#fff" }, this.$ball);
      el("circle", { r: 10, fill: "url(#" + this._uid + "-shade)" }, this.$ball);
      el("circle", { r: 10, fill: "none", stroke: "#2a211c", "stroke-opacity": .25, "stroke-width": 1 }, this.$ball);

      // tray front
      el("path", { d: "M136 311 L254 311 L249 329 L141 329 Z", fill: "#dcae72" }, svg);
      el("path", { d: "M136 311 L254 311", stroke: "#f3dcb0", "stroke-width": 2, opacity: .8 }, svg);
      el("path", { d: "M141 326 L249 326 L249 329 L141 329 Z", fill: "#94622f", opacity: .6 }, svg);

      // crank
      var crankRot = el("g", null, svg); this._spins.push(crankRot);
      var hd = el("g", { "class": "handle", tabindex: 0, role: "slider", "aria-valuemin": 0, "aria-valuenow": 0 }, crankRot);
      this.$handle = hd;
      var ARM = "M195 170 Q 258 152 300.7 81.3";
      el("path", { d: ARM, fill: "none", stroke: "#2c303a", "stroke-width": 13, "stroke-linecap": "round" }, hd);
      el("path", { d: "M197 166 Q 256 150 298 84", fill: "none", stroke: "#8a91a1", "stroke-width": 3, "stroke-linecap": "round", opacity: .6 }, hd);
      el("circle", { cx: 195, cy: 170, r: 7, fill: "#2c303a" }, hd);
      el("circle", { "class": "pulse", cx: 300.7, cy: 81.3, r: 21 }, hd);
      el("circle", { cx: 300.7, cy: 81.3, r: 19, fill: "#8e221d" }, hd);
      el("circle", { "class": "knob-ring", cx: 300.7, cy: 81.3, r: 15, fill: "#b5302a", stroke: "#8e221d", "stroke-width": 1 }, hd);
      el("ellipse", { cx: 295, cy: 75.5, rx: 5.5, ry: 3.6, fill: "#fff", opacity: .45, transform: "rotate(-35 295 75.5)" }, hd);
      el("path", { "class": "arm-hit", d: ARM }, hd);
      el("circle", { "class": "knob-hit", cx: 300.7, cy: 81.3, r: 42 }, hd);

      // rotation hint (double-headed arc)
      var hint = el("g", { "class": "hint-g", "aria-hidden": "true" }, svg);
      el("path", { "class": "hint", d: "M240 16 A160 160 0 0 1 352.6 142.2" }, hint);
      function head(px, py, dx, dy) {
        var nx = -dy, ny = dx;
        el("path", { "class": "hint-head", d: "M" + (px + dx * 7).toFixed(1) + " " + (py + dy * 7).toFixed(1) + " L" + (px - dx * 3 + nx * 5).toFixed(1) + " " + (py - dy * 3 + ny * 5).toFixed(1) + " L" + (px - dx * 3 - nx * 5).toFixed(1) + " " + (py - dy * 3 - ny * 5).toFixed(1) + " Z" }, hint);
      }
      var aS = Math.atan2(16 - CY, 240 - CX), aE = Math.atan2(142.2 - CY, 352.6 - CX);
      head(240, 16, Math.sin(aS), -Math.cos(aS));
      head(352.6, 142.2, -Math.sin(aE), Math.cos(aE));

      this.$words = el("g", { "aria-hidden": "true" }, svg);

      // interaction
      var self = this;
      hd.addEventListener("pointerdown", function (e) { self._onDown(e); });
      hd.addEventListener("touchstart", function (e) { if (self._canSpin()) e.preventDefault(); }, { passive: false });
      svg.addEventListener("pointermove", function (e) { self._onMove(e); });
      svg.addEventListener("pointerup", function (e) { self._onUp(e); });
      svg.addEventListener("pointercancel", function (e) { self._onUp(e); });
      hd.addEventListener("keydown", function (e) {
        var d = 0;
        if (e.key === "ArrowRight" || e.key === "ArrowDown" || e.key === " " || e.key === "Enter") d = 30;
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") d = -30;
        if (!d || !self._canSpin()) return;
        e.preventDefault(); self._sound.ctx(); self._step(d);
      });
    }

    _buildSlots() {
      var n = this._turnCount();
      this.$slotsBox.textContent = "";
      this._slots = [];
      for (var i = 0; i < n; i++) {
        var s = document.createElement("span"); s.className = "slot";
        this.$slotsBox.appendChild(s); this._slots.push(s);
      }
      if (this.$handle) this.$handle.setAttribute("aria-valuemax", n);
    }

    _applyTexts() {
      var t = this._texts, r = this.shadowRoot;
      var set = function (sel, v) { var n = r.querySelector(sel); if (n) { n.textContent = v || ""; } };
      set(".lock-default", t.lockedDefault);
      set(".t-done", t.doneTitle); set(".t-done-sub", t.doneSub); set(".again", t.showResult);
      set(".m-eye", t.congrats); set(".t-goods", t.goodsText); set(".t-goods-note", t.goodsNote);
      set(".lab", t.couponLabel); set(".t-coupon", t.couponText); set(".t-coupon-note", t.couponNote);
      set(".copy", t.copy); set(".close", t.close);
      r.querySelector(".t-coupon-note").hidden = !t.couponNote;
      r.querySelector(".t-goods-note").hidden = !t.goodsNote;
      this.$handle.setAttribute("aria-label", t.handleLabel);
      this._applySoundBtn();
      this._updateProgress();
    }
    _applySoundBtn() {
      this.$sound.setAttribute("aria-pressed", this._sound.on);
      this.shadowRoot.querySelector(".sound-txt").textContent = this._sound.on ? this._texts.soundOn : this._texts.soundOff;
      this.shadowRoot.querySelector(".sw").style.display = this._sound.on ? "" : "none";
    }

    /* ---------- state ---------- */
    _turnCount() { var n = parseInt(this.getAttribute("turns"), 10); return isNaN(n) ? 3 : Math.max(1, Math.min(5, n)); }
    _target() { return this._turnCount() * 360; }
    _canSpin() { return this._phase === "ready" || this._phase === "spinning"; }
    _resetMachine() {
      cancelAnimationFrame(this._raf);
      this._theta = 0; this._total = 0; this._vel = 0; this._dragging = false; this._error = false;
      this.$ball.setAttribute("visibility", "hidden");
      this.$words.textContent = "";
      this._phase = this.getAttribute("state") === "locked" ? "locked" : "ready";
      this._render(); this._syncStage();
    }
    _syncStage() {
      var ph = this._phase;
      this.$stage.classList.toggle("is-ready", ph === "ready");
      this.$stage.classList.toggle("is-locked", ph === "locked");
      this.$stage.classList.toggle("is-done", ph === "done");
      this.$lock.hidden = ph !== "locked";
      this.$progress.hidden = ph === "done";
      this.$done.hidden = ph !== "done";
      this.$handle.setAttribute("tabindex", this._canSpin() ? 0 : -1);
      this._updateProgress();
    }
    _render() {
      var t = "rotate(" + this._theta.toFixed(2) + " " + CX + " " + CY + ")";
      for (var i = 0; i < this._spins.length; i++) this._spins[i].setAttribute("transform", t);
    }
    _updateProgress() {
      if (!this._slots) return;
      var n = this._turnCount(), turns = Math.min(this._total / 360, n), t = this._texts;
      this._slots.forEach(function (s, i) { s.style.setProperty("--p", Math.max(0, Math.min(1, turns - i)).toFixed(3)); });
      this.$handle.setAttribute("aria-valuenow", turns.toFixed(1));
      if (this._phase === "finishing") { this.$title.textContent = t.drawing; this.$sub.textContent = t.drawingSub; return; }
      if (this._error && this._total === 0) { this.$title.textContent = t.errorTitle; this.$sub.textContent = t.errorSub; return; }
      var left = Math.max(0, Math.ceil((this._target() - this._total) / 360 - 1e-6));
      this.$title.textContent = this._total === 0 ? t.turnsLeft.replace("{n}", n) : (left <= 1 ? t.almost : t.turnsLeft.replace("{n}", left));
      this.$sub.textContent = this._total === 0 ? t.hintStart : t.hintGoing;
    }

    /* ---------- spinning ---------- */
    _spawnWord() {
      if (reduceMotion()) return;
      var w = this._texts.words || [];
      if (!w.length) return;
      var ang = (-150 + Math.random() * 120) * Math.PI / 180;
      var tx = el("text", { x: (CX + Math.cos(ang) * 92).toFixed(1), y: (CY + Math.sin(ang) * 92).toFixed(1), "text-anchor": "middle", "class": "word" }, this.$words);
      tx.textContent = w[this._wordIdx++ % w.length];
      setTimeout(function () { tx.remove(); }, 950);
    }
    _addRotation(d) {
      var before = this._total;
      this._theta += d; this._total += Math.abs(d);
      if (d) this._dir = d > 0 ? 1 : -1;
      if (Math.floor(this._total / 45) > Math.floor(before / 45)) {
        this._sound.clack();
        if (Math.floor(this._total / 180) > Math.floor(before / 180)) this._spawnWord();
        try { if (navigator.vibrate) navigator.vibrate(6); } catch (e) {}
      }
      this._render(); this._updateProgress();
    }
    _step(d) {
      if (!this._canSpin()) return;
      if (this._phase === "ready") {
        this._phase = "spinning"; this._error = false; this.$stage.classList.remove("is-ready");
        this._emit("garapon:spin-start", {});
      }
      this._addRotation(d);
      if (this._total >= this._target()) this._finish();
    }
    _angleOf(e) {
      var pt = this.$svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
      var p = pt.matrixTransform(this.$svg.getScreenCTM().inverse());
      return Math.atan2(p.y - CY, p.x - CX) * 180 / Math.PI;
    }
    _onDown(e) {
      if (!this._canSpin()) return;
      e.preventDefault();
      this._sound.ctx();
      this._dragging = true; this.$stage.classList.add("dragging");
      this._lastAng = this._angleOf(e); this._lastT = performance.now(); this._vel = 0;
      cancelAnimationFrame(this._raf);
      try { this.$svg.setPointerCapture(e.pointerId); } catch (err) {}
    }
    _onMove(e) {
      if (!this._dragging) return;
      var a = this._angleOf(e), d = a - this._lastAng;
      while (d > 180) d -= 360; while (d < -180) d += 360;
      this._lastAng = a;
      if (Math.abs(d) > 100) return;
      var now = performance.now(), dt = Math.max(now - this._lastT, 8); this._lastT = now;
      this._vel = Math.max(-26, Math.min(26, this._vel * .6 + (d / dt * 16.7) * .4));
      this._step(d);
    }
    _onUp(e) {
      if (!this._dragging) return;
      this._dragging = false; this.$stage.classList.remove("dragging");
      try { this.$svg.releasePointerCapture(e.pointerId); } catch (err) {}
      if (this._phase === "spinning") this._coast();
    }
    _onTouchMove(e) { if (this._dragging) e.preventDefault(); }
    _coast() {
      var self = this;
      cancelAnimationFrame(this._raf);
      (function loop() {
        if (self._dragging || self._phase !== "spinning") return;
        if (Math.abs(self._vel) < .15) { self._vel = 0; return; }
        self._step(self._vel); self._vel *= .955;
        self._raf = requestAnimationFrame(loop);
      })();
    }

    /* ---------- drawing ---------- */
    _validResult(r) { return !!(r && this._prizes[Number(r.rank)]); }
    _requestResult() {
      var self = this;
      if (typeof this.drawHandler !== "function") {
        return Promise.reject(new Error("drawHandler is not set"));
      }
      return Promise.resolve().then(function () { return self.drawHandler(); }).then(function (r) {
        if (!self._validResult(r)) throw new Error("drawHandler returned an invalid result: " + JSON.stringify(r));
        return { rank: Number(r.rank), code: r.code ? String(r.code) : "" };
      });
    }
    _finish() {
      var self = this;
      this._phase = "finishing"; this._dragging = false; this._vel = 0;
      this.$stage.classList.remove("dragging");
      cancelAnimationFrame(this._raf);
      this._updateProgress();

      var resultP = this._requestResult();
      var stopP = new Promise(function (resolve) {
        var target = self._dir > 0 ? Math.ceil(self._theta / 360) * 360 : Math.floor(self._theta / 360) * 360;
        if (Math.abs(target - self._theta) < 70) target += 360 * self._dir;
        var from = self._theta, dur = reduceMotion() ? 300 : 1300, t0 = performance.now();
        (function anim(now) {
          var k = Math.min(1, (now - t0) / dur), ease = 1 - Math.pow(1 - k, 3);
          self._addRotation(from + (target - from) * ease - self._theta);
          if (k < 1) self._raf = requestAnimationFrame(anim);
          else { self._theta = 0; self._render(); resolve(); }
        })(t0);
      });

      Promise.all([resultP, stopP]).then(function (v) {
        self._result = v[0];
        setTimeout(function () { self._dropBall(); }, 180);
      }, function (err) {
        stopP.then(function () {
          console.error("[myzoo-garapon]", err);
          self._emit("garapon:error", { error: err });
          self._resetMachine();
          self._error = true;
          self._updateProgress();
        });
      });
    }
    _setBall(rank, x, y, s) {
      var pz = this._prizes[rank];
      this.$ballFill.setAttribute("fill", pz ? pz.color : "#fff");
      this.$ball.setAttribute("visibility", "visible");
      this.$ball.setAttribute("transform", "translate(" + x.toFixed(1) + " " + y.toFixed(1) + ") scale(" + s.toFixed(3) + ")");
    }
    _dropBall() {
      var self = this, rank = this._result.rank, t0 = performance.now();
      (function popOut(now) {
        var k = Math.min(1, (now - t0) / 260);
        self._setBall(rank, 195, 246 + 8 * k, .25 + .75 * k);
        if (k < 1) requestAnimationFrame(popOut); else fall();
      })(t0);
      function fall() {
        var x = 195, y = 254, vy = 0, vx = .014, g = .0011, rest = 307, bounces = 0, last = performance.now();
        (function loop(now) {
          var dt = Math.min(32, now - last); last = now;
          vy += g * dt; y += vy * dt; x += vx * dt;
          if (y >= rest) {
            y = rest;
            if (bounces < 3 && vy > .05) { self._sound.koron(Math.min(1, vy * 3)); vy = -vy * .36; bounces++; }
            else { vy = 0; vx *= .9; }
          }
          self._setBall(rank, x, y, 1);
          if (vy !== 0 || Math.abs(vx) > .002) requestAnimationFrame(loop);
          else setTimeout(function () {
            self._phase = "done"; self._syncStage();
            self._emit("garapon:result", Object.assign({}, self._result, { prize: Object.assign({}, self._prizes[rank]) }));
            self._showModal(true);
          }, 420);
        })(last);
      }
    }

    /* ---------- popup ---------- */
    _showModal(celebrate) {
      var r = this.shadowRoot, res = this._result, pz = this._prizes[res.rank];
      var isCoupon = pz.type === "coupon";
      var ball = r.querySelector(".big-ball");
      var photo = r.querySelector(".prize-photo");
      ball.style.setProperty("--ball", pz.color);
      // 【中獎彈窗】有商品首圖／六等獎圖片時，以圖片取代彩球；沒設定時保留彩球。
      // 使用屬性而非 HTML 字串，以避免圖片路徑被解讀成標籤。
      photo.hidden = true;
      photo.removeAttribute("src");
      photo.alt = "";
      ball.hidden = false;
      if (pz.image) {
        photo.onload = function () { photo.hidden = false; ball.hidden = true; };
        photo.onerror = function () { photo.hidden = true; ball.hidden = false; };
        photo.alt = pz.name;
        photo.src = pz.image;
        if (photo.complete && photo.naturalWidth > 0) { photo.hidden = false; ball.hidden = true; }
      }
      r.querySelector(".m-rank").textContent = pz.label;
      r.querySelector(".m-prize").textContent = pz.name;
      r.querySelector(".m-goods").hidden = isCoupon;
      r.querySelector(".m-coupon").hidden = !isCoupon;
      r.querySelector(".code").textContent = res.code || "";
      r.querySelector(".copy").textContent = this._texts.copy;
      r.querySelector(".copy").hidden = !res.code;
      this.$modal.hidden = false;
      r.querySelector(".close").focus({ preventScroll: true });
      if (celebrate) { this._sound.chime(res.rank <= 3); this._confetti(res.rank <= 3 ? 140 : 70); }
    }
    _closeModal() {
      if (this.$modal.hidden) return;
      this.$modal.hidden = true;
      this._emit("garapon:close", {});
    }
    _onKeyEsc(e) { if (e.key === "Escape" && this.$modal && !this.$modal.hidden) this._closeModal(); }
    _copy(btn) {
      var self = this, codeEl = this.shadowRoot.querySelector(".code");
      function ok() { btn.textContent = self._texts.copied; }
      function fallback() {
        try {
          var range = document.createRange(); range.selectNodeContents(codeEl);
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
        } catch (e) {}
        btn.textContent = self._texts.copySelected;
      }
      try { navigator.clipboard.writeText(codeEl.textContent).then(ok, fallback); } catch (e) { fallback(); }
    }
    _confetti(n) {
      if (reduceMotion()) return;
      var cv = this.$confetti, cx = cv.getContext("2d");
      var dpr = Math.min(2, window.devicePixelRatio || 1), W = innerWidth, H = innerHeight;
      cv.width = W * dpr; cv.height = H * dpr; cx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var cols = ["#c2423a", "#e79aa3", "#d9bf80", "#f6efe0", "#b5302a"], ps = [];
      for (var i = 0; i < n; i++) ps.push({ x: Math.random() * W, y: -20 - Math.random() * H * .5, vy: 1.2 + Math.random() * 2, vx: -.6 + Math.random() * 1.2, r: 3 + Math.random() * 4, a: Math.random() * 6, va: -.05 + Math.random() * .1, c: cols[i % cols.length], sw: Math.random() * 6 });
      var t0 = performance.now();
      (function loop(now) {
        var el2 = now - t0; cx.clearRect(0, 0, W, H);
        ps.forEach(function (p) {
          p.y += p.vy; p.x += p.vx + Math.sin(now / 400 + p.sw) * .6; p.a += p.va;
          cx.save(); cx.translate(p.x, p.y); cx.rotate(p.a);
          cx.globalAlpha = el2 > 2600 ? Math.max(0, 1 - (el2 - 2600) / 800) : 1;
          cx.fillStyle = p.c; cx.beginPath(); cx.ellipse(0, 0, p.r, p.r * .62, 0, 0, Math.PI * 2); cx.fill(); cx.restore();
        });
        if (el2 < 3400) requestAnimationFrame(loop); else cx.clearRect(0, 0, W, H);
      })(t0);
    }

    _emit(name, detail) {
      this.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true, composed: true }));
    }
  }

  customElements.define("myzoo-garapon", MyzooGarapon);
})();
